import { DateTrunc } from '../../../models';
import { defaultDateWindow } from './defaultDateWindow';
import { ALL_TIME_DATE_WINDOW } from '../types/allTimeDateWindow';
import { DateWindow } from './DateWindow';
import { createRelativeWindow } from '../types/latestDataDateWindow';
import { createLastNWindow } from '../types/lastNDateWindow';

export const dateWindowOptions = (dateTrunc: DateTrunc): ReadonlyArray<DateWindow> => {
  switch (dateTrunc) {
    case DateTrunc.SECOND: {
      return [
        createRelativeWindow({ unit: DateTrunc.MINUTE, numberOfUnits: 1 }),
        createRelativeWindow({ unit: DateTrunc.MINUTE, numberOfUnits: 3 }),
        createRelativeWindow({ unit: DateTrunc.MINUTE, numberOfUnits: 15 }),
        ALL_TIME_DATE_WINDOW,
      ];
    }
    case DateTrunc.MINUTE: {
      return [
        createRelativeWindow({ unit: DateTrunc.HOUR, numberOfUnits: 1 }),
        createRelativeWindow({ unit: DateTrunc.HOUR, numberOfUnits: 3 }),
        createRelativeWindow({ unit: DateTrunc.HOUR, numberOfUnits: 12 }),
        ALL_TIME_DATE_WINDOW,
      ];
    }
    case DateTrunc.HOUR: {
      return [
        createRelativeWindow({ unit: DateTrunc.DAY, numberOfUnits: 1 }),
        createRelativeWindow({ unit: DateTrunc.DAY, numberOfUnits: 3 }),
        createRelativeWindow({ unit: DateTrunc.DAY, numberOfUnits: 7 }),
        createRelativeWindow({ unit: DateTrunc.DAY, numberOfUnits: 30 }),
        ALL_TIME_DATE_WINDOW,
      ];
    }
    case DateTrunc.DAY: {
      return [
        createRelativeWindow({ unit: DateTrunc.DAY, numberOfUnits: 7 }),
        createRelativeWindow({ unit: DateTrunc.DAY, numberOfUnits: 30 }),
        createRelativeWindow({ unit: DateTrunc.DAY, numberOfUnits: 90 }),
        createRelativeWindow({ unit: DateTrunc.DAY, numberOfUnits: 365 }),
        ALL_TIME_DATE_WINDOW,
      ];
    }
    case DateTrunc.WEEK: {
      return [
        createRelativeWindow({ unit: DateTrunc.WEEK, numberOfUnits: 4 }),
        createRelativeWindow({ unit: DateTrunc.WEEK, numberOfUnits: 12 }),
        createRelativeWindow({ unit: DateTrunc.WEEK, numberOfUnits: 52 }),
        ALL_TIME_DATE_WINDOW,
      ];
    }
    case DateTrunc.MONTH: {
      return [
        createRelativeWindow({ unit: DateTrunc.MONTH, numberOfUnits: 12 }),
        createRelativeWindow({ unit: DateTrunc.MONTH, numberOfUnits: 60 }),
        ALL_TIME_DATE_WINDOW,
      ];
    }
    case DateTrunc.ISO_QTR:
    case DateTrunc.QUARTER: {
      return [
        createRelativeWindow({ unit: DateTrunc.QUARTER, numberOfUnits: 4 }),
        createRelativeWindow({ unit: DateTrunc.QUARTER, numberOfUnits: 8 }),
        ALL_TIME_DATE_WINDOW,
      ];
    }
    case DateTrunc.UNKNOWN: {
      return [createLastNWindow(30), createLastNWindow(100), createLastNWindow(300), ALL_TIME_DATE_WINDOW];
    }

    default: {
      return [defaultDateWindow(dateTrunc), defaultDateWindow(DateTrunc.NONE)];
    }
  }
};
